import {BaseEndpoint} from "@/api/BaseEndpoint";

class FairCategories extends BaseEndpoint{}

export default (new FairCategories('fair-categories'));